const BASE = "/user_suggestions";

export const SUGGESTIONS_ENDPOINTS = {
  LIST_SUGGESTIONS: BASE,
  CREATE_SUGGESTION: BASE,
  UPDATE_SUGGESTION: (id: string) => `${BASE}/${id}`,
} as const;
